// Local
/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import {
  SET_ACTIVE_PET,
  SET_KITTEN,
  SET_SHUFFLE_PETS,
} from '../constants';

import shuffleActivePetType from '../utils/shuffleActivePetType';
import getRandom from '../utils/getRandom';
import getCollectedPetTypes from '../selectors/getCollectedPetTypes';


// --- SET ACTIVE PET --- //

export function setActivePet(pet) {
  return {
    type: SET_ACTIVE_PET,
    payload: {
      pet,
    },
  };
}

export function setActivePetAsync(pet) {
  return (dispatch, getState) => {

    // If shuffle was on, turn it off.
    if (getState().activePet.shuffle) {
      dispatch(setShuffle(false));
    }

    // If the new pet is different, set the new active pet.
    if (getState().activePet.active.petType.sku !== pet.petType.sku) {
      dispatch(setActivePet(pet));
    }
  };
}


// --- KITTEN --- //

export function setKitten(kitten) {
  return {
    type: SET_KITTEN,
    payload: {
      kitten,
    },
  };
}


// --- SHUFFLE --- //

function setShuffle(isShuffle) {
  return {
    type: SET_SHUFFLE_PETS,
    payload: {
      isShuffle,
    },
  };
}

// Find the last shuffle state, then shuffle goodies if necessary.
export function setShuffleAsync() {
  return (dispatch, getState) => {
    const lastShuffleState = getState().activePet.shuffle;

    // Toggle shuffle.
    dispatch(setShuffle(!lastShuffleState));

    // If shuffle is now true, set a new pet
    if (lastShuffleState === false) {
      // Filter out the current active pet.
      const currentActivePet = getState().activePet.active.petType;
      const newPetsToPickFrom = _.filter(getCollectedPetTypes(getState().allPets), pet => pet.sku !== currentActivePet.sku);
      // Construct the new pet
      const newActivePetType = shuffleActivePetType(newPetsToPickFrom);
      const newActivePet = {
        petType: newActivePetType,
        ...getRandom.petOfTypeForPetPicker(newActivePetType.type),
      };

      dispatch(setActivePet(newActivePet));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/activePet.js